import React from 'react';
import { useNavigate } from 'react-router-dom';
import ChangePassForm from '../../components/change-pass/ChangePassForm';
import Storage from '../../services/Storage';



export default function ChangePassword() {
  const navigate = useNavigate();
  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])

  return (
    <ChangePassForm> </ChangePassForm>
  );
}


